var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lkps-table',{attrs:{"api-endpoint":_vm.apiEndpoint,"headers":_vm.headers,"form":_vm.form,"is-calculation-enable":true,"single-export":"Dapat Ditinjau"}})}
var staticRenderFns = []

export { render, staticRenderFns }